import firebase from "firebase/app";
import "firebase/messaging";
import { FiChrome } from "react-icons/fi";
import CONFIG from "../config";
import { toastMessage } from "./toast";

var apiKey = "";
var authDomain = "";
var projectId = "";
var storageBucket = "";
var messagingSenderId = "";
var appId = "";
var measurementId = "";
var web_push_certificates = "";

if (CONFIG.env === "preProd" || CONFIG.env === "prod") {
  apiKey = "AIzaSyBdsZ3ja3D2P1o8P8Vd3zRWX1ZCNs5-zTM";
  authDomain = "aamer-hub-live.firebaseapp.com";
  projectId = "aamer-hub-live";
  storageBucket = "aamer-hub-live.appspot.com";
  messagingSenderId = "986298405378";
  appId = "1:986298405378:web:6b092304a5078b85704d1b";
  measurementId = "G-MTFBT3PDNM";
  web_push_certificates =
    "BAcQDW1LGeomqmM4s8fkcM-NKl9NH2x-HQ-jtYDVlT25JK6D5SEwYqJWqIHTlFLWAJ3vEgmM3tpccZ6AlWcrFhg";
} else {
  apiKey = "AIzaSyApcbhXdvyukd-EJrLA23M4Dicvyoc0Rnw";
  authDomain = "aamer-testing-81874.firebaseapp.com";
  projectId = "aamer-testing-81874";
  storageBucket = "aamer-testing-81874.appspot.com";
  messagingSenderId = "922603855270";
  appId = "1:922603855270:web:a7725486ba44b11ff64367";
  measurementId = "G-B5DNFNQ6VM";
  web_push_certificates =
    "BIRvcxK3pfgyLMmWHRcvUIeQUIvum_B8SDtU8_kY6TjkTpAL6OB0ZRts2SLKILPiu0N6a3SHO-qCczU8V2X9AZY";
}

const firebaseConfig = {
  apiKey: apiKey,
  authDomain: authDomain,
  projectId: projectId,
  storageBucket: storageBucket,
  messagingSenderId: messagingSenderId,
  appId: appId,
  measurementId: measurementId,
};

firebase.initializeApp(firebaseConfig);
const messaging = firebase.messaging();


export const getToken = (setFcmToken) => {
  return messaging
    .getToken({ vapidKey: web_push_certificates })
    .then((currentToken) => {
      if (currentToken) {
       // setFcmToken(currentToken);
       setFcmToken("");
        // Track the token -> client mapping, by sending to backend server
        // show on the UI that permission is secured
      } else {
        console.log(
          "No registration token available. Request permission to generate one."
        );
        setFcmToken("");
        // shows on the UI that permission is required
      }
    })
    .catch((err) => {
      console.log("An error occurred while retrieving token. ", err);
      // catch error while creating client token
    });
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    messaging.onMessage((payload) => {
      const notificationTitle = payload?.data?.title;
      const notificationOptions = {
        body: payload?.data?.body,
        icon: payload?.data?.icon,
      };
      let jobId = payload?.data?.jobID;
      
      if (payload?.data?.type == "AWAITING_PAYMENT") {
        window.location.href = `/checkout/${jobId}`;
      } else if (payload?.data?.type == "REQUEST_SUBMIT") {
        window.location.reload();
      }
      const notification = new Notification(
        notificationTitle,
        notificationOptions
      );
      notification.addEventListener("click", () => {
        if (payload.data.type == "ADDITIONAL_PAYMENT_AWAITING_PAYMENT") {
          window.location.href = `/additionalPayment/${jobId}`;
        } else if (payload?.data?.type == "AWAITING_RESPONSE") {
          localStorage.setItem("ErroredJobUrl", payload?.data?.jobURL);
          window.location.href = "/jobs";
        }
      });
    });
  });

// browser.runtime.onMessage.addListener(
//   (data, sender) => {
//     if( !(data.type === 'handle_me')){
//       console.log(" submited")

//       return Promise.resolve('done');
//     }
//     return false;
//   }
// );
